import React, { useState, useContext, useEffect, useRef, useCallback } from 'react';
import { useParams, useNavigate } from "react-router-dom";
import {localizeKey, localizeArt} from './../localize.js';
import axiosInstance from './../axiosInstance.js';
import MyUserContext from './../myUserContext.js';
import Collapsible from './Collapsible';
import LinkInput from './LinkInput';
import SelectableTags from './SelectableTags';
import ShareButton from './ShareButton';
import { Link } from 'react-router-dom';
import PlatformRatings from './PlatformRatings';
import ArtPage from './ArtPage';
// import ArtThumbnail from './ArtThumbnail';
import TagBadge, { tagBadgeColor, tagName } from "./TagBadge";
import { saveStateAndScroll, restoreStateAndScroll } from './../utils/stateManager';
import ExpandableImage from './ExpandableImage';
import 'delayed-scroll-restoration-polyfill';
import ArtThumbnail from './ArtThumbnail.js';
import TextUserPair from './TextUserPair.js';
import { formatYear } from './../utils.js'; // Import the global function
import {
  ActionIcon,
  Button,
  Group,
  Image,
  Paper,
  Stack,
  Text,
  TextInput
} from "@mantine/core";

const PersonalArtEvents = ({eventType, userId, repeatedEnter = 0}) => {
  const navigate = useNavigate();

  const myUser = useContext(MyUserContext);
  const [finishedInput, setFinishedInput] = useState("");
  const [finishedEvents, setFinishedEvents] = useState(null);

  const [hasAccess, setHasAccess] = useState(true);
  const [followersCount, setFollowersCount] = useState(null);
  const [followeesCount, setFolloweesCount] = useState(null);

  const [artNameTerm, setArtNameTerm] = useState('');

  const { pathUserId } = useParams();
  const effectiveUserId = () => {
    // UserID from props or path param.
    let effectiveUserId = userId;
    if (!effectiveUserId) {
      effectiveUserId = pathUserId;
    }
    return effectiveUserId;
  }

  const alreadySelectedTagIds = new URLSearchParams(window.location.search).getAll('tags');

  const alreadySelectedTagIdsParam = alreadySelectedTagIds.map((t) => { return "tags="+t}).join("&");
  const initEventsFetchUrl = `/artEvents/${effectiveUserId()}/${eventType}?${alreadySelectedTagIdsParam}`;
  const [nextUrl, setNextUrl] = useState(initEventsFetchUrl);
  const [loading, setLoading] = useState(false);
  const observer = useRef();
  const latestRequestIdRef = useRef(0);

  const searchInputRef = useRef(null);
  const [shouldFocus, setShouldFocus] = useState(false);
  const [gridClass, setGridClass] = useState('grid-cols-4');
  const [openGlobalManualTagEventId, setOpenGlobalManualTagEventId] = useState(null);
  const [selectedGridItemIdx, setSelectedGridItemIdx] = useState(null);
  const [gridArtDetails, setGridArtDetails] = useState({});

  const scrollDetailIntoView = (el) => {
    if (!el) return;
    requestAnimationFrame(() => {
      const rect = el.getBoundingClientRect();
      if (rect.bottom > window.innerHeight) {
        window.scrollBy({ top: rect.bottom - window.innerHeight + 60, behavior: 'smooth' });
      }
    });
  };

  const handleSelectGridItem = (idx) => {
    if (selectedGridItemIdx === idx) {
      setSelectedGridItemIdx(null);
      return;
    }
    setSelectedGridItemIdx(idx);
    // Fetch art details on demand
    const item = finishedEvents[idx];
    if (item && !gridArtDetails[item.art.id]) {
      axiosInstance.get(`/arts/${item.art.id}/`)
        .then((response) => {
          setGridArtDetails(prev => ({ ...prev, [item.art.id]: response.data }));
        })
        .catch((error) => console.error('Failed to fetch art details:', error));
    }
  };

  const globalManualTags = ["like", "veryGood", "good", "finished", "bad", "inProgress", "todo"];

  const toggleGridCols = () => {
    setGridClass((prevClass) => (prevClass === 'grid-cols-4' ? 'grid-cols-6' : 'grid-cols-4'));
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!openGlobalManualTagEventId) {
        return;
      }
      const menuSelector = `[data-global-tag-menu-id="${openGlobalManualTagEventId}"]`;
      if (!event.target.closest(menuSelector)) {
        setOpenGlobalManualTagEventId(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [openGlobalManualTagEventId]);

  const prevRepeatedEnterRef = useRef(repeatedEnter);
  useEffect(() => {
    if (repeatedEnter !== prevRepeatedEnterRef.current) {
      prevRepeatedEnterRef.current = repeatedEnter;
      setShouldFocus(true);
    }
  }, [repeatedEnter]);

  useEffect(() => {
    if (searchInputRef.current) {
      if (shouldFocus) {
        searchInputRef.current.focus();
      } else {
        searchInputRef.current.blur();
      }
    }
  }, [shouldFocus]);

  useEffect(() => {
    // Enable scroll restoration
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  }, []);

  useEffect(() => {
    setFinishedEvents(null);
    setCurUser(null);
    setNextUrl(`/artEvents/${effectiveUserId()}/${eventType}?${alreadySelectedTagIdsParam}`);
    setFetching(false);
    setHasAccess(true);
    setFollowersCount(null);
    setFolloweesCount(null);
  }, [pathUserId, eventType]);

  // TODO: use this to save state and scroll position when navigating away
  // useEffect(() => {
  //   // Restore state and scroll when navigating back
  //   restoreStateAndScroll((restoredState) => {
  //     if (restoredState) {
  //       setFinishedEvents(restoredState.finishedEvents || null);
  //       setArtNameTerm(restoredState.artNameTerm || '');
  //       setNextUrl(restoredState.nextUrl || initEventsFetchUrl);
  //     }
  //   });
  // }, []);

  // const handleNavigation = () => {
  //   // Save state and scroll before navigating away
  //   saveStateAndScroll(window.location.pathname, {
  //     finishedEvents,
  //     artNameTerm,
  //     nextUrl,
  //   });
  //   navigate('/some-other-path'); // Example navigation
  // };

  const [fetching, setFetching] = useState(false);

  const [curUser, setCurUser] = useState(null); // some other user
  const fetchCurUser = () => {
    axiosInstance
    .get(`/users/${effectiveUserId()}`)
    .then((response) => {
      setCurUser(response.data);
    })
    .catch((error) => {
      console.error(error);      
    });
  }

  const fetchFollowCounts = () => {
    const targetUserId = effectiveUserId();
    if (!targetUserId) {
      setFollowersCount(null);
      setFolloweesCount(null);
      return;
    }

    Promise.all([
      axiosInstance.get(`/getUsers?onlyMyFollowers=true&forUserId=${targetUserId}`),
      axiosInstance.get(`/getUsers?onlyMyFollowees=true&forUserId=${targetUserId}`)
    ])
    .then(([followersResponse, followeesResponse]) => {
      setFollowersCount(followersResponse.data.length);
      setFolloweesCount(followeesResponse.data.length);
    })
    .catch((error) => {
      console.error(error);
    });
  };

  const [relevantTags, setRelevantTags] = useState(null);
  const fetchRelevantTags = (alreadySetTagIds=[]) => {
    const tagParams = alreadySetTagIds.map((n) => { return "alreadySetTags="+n; }).join("&");
    axiosInstance
    .get(`/relevant/tags?userId=${effectiveUserId()}&type=${eventType}&${tagParams}`)
    .then((response) => {
      setRelevantTags(response.data);
    })
    .catch((error) => {
      console.error(error);
    })
  }

  const [showTags, setShowTags] = useState(false);

  const [unfinishedRecomsCount, setUnfinishedRecomsCount] = useState(null);
  const fetchUnfinishedRecomsCount = () => {
    axiosInstance
    .get('/recommendations/unfinished/count')
    .then((response) => {
      setUnfinishedRecomsCount(response.data.unfinished);
    })
    .catch((error) => {
      // console.error(error.message);
    })
  }

  const [selectedItem, setSelectedItem] = useState(null);

  const modalRef = useRef(null);
  const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);

  const isTouchDevice = () => 'ontouchstart' in window || navigator.maxTouchPoints > 0;

  const preventDefault = (e) => {
    e.preventDefault();
  };

  const handleTouchStart = (e) => {
    setIsDragging(true);
    const rect = modalRef.current.getBoundingClientRect();
    setDragOffset({
      x: e.touches[0].clientX - rect.left,
      y: e.touches[0].clientY - rect.top,
    });
  };

  const handleTouchMove = (e) => {
    if (!isDragging) return;
    const modal = modalRef.current;
    const deltaX = e.touches[0].clientX - dragOffset.x;
    const deltaY = e.touches[0].clientY - dragOffset.y;
    if (deltaX < 0) {
      return; // Prevent dragging to the left
    }

    // Enable drag only if deltaX > deltaY
    if (Math.abs(deltaX) > Math.abs(deltaY)) {
      // Disable scrolling.
      modal.style.overflow = 'hidden';
      modal.addEventListener('touchmove', preventDefault, { passive: false });

      modal.style.transform = `translate(${deltaX}px, 0)`;

      // Reduce width and height proportionally, scale more slowly
      const scale = 1 - Math.min(deltaX / (window.innerWidth * 2), 0.1); // Limit reduction to 10%
      modal.style.transform += ` scale(${scale})`;

      // Enable vertical drag after horizontal drag
      if (Math.abs(deltaX) > 70) {
        modal.style.transform = `translate(${deltaX}px, ${deltaY}px) scale(${scale})`;
      }
    }
  };

  const handleTouchEnd = () => {
    setIsDragging(false);

    // Enable scrolling again.
    modalRef.current.style.overflow = 'auto';
    modalRef.current.removeEventListener('touchmove', preventDefault);

    const rect = modalRef.current.getBoundingClientRect();
    const modalWidth = rect.width;

    // Close modal if dragged to the right by at least 20% of its width
    if (rect.left - dragOffset.x > modalWidth / 5) {
      setSelectedItem(null);
    } else {
      // Reset position if not dragged far enough
      modalRef.current.style.transform = "translate(0, 0)";
    }
  };

  const fetchFinishedEvents = useCallback((nextUrl, fromScratch = false) => {
    if (!nextUrl || (loading && !fromScratch)) {
      return;
    }
    const requestId = latestRequestIdRef.current + 1;
    latestRequestIdRef.current = requestId;
    setLoading(true);
    axiosInstance
    .get(nextUrl)
    .then((response) => {
      if (latestRequestIdRef.current !== requestId) {
        return;
      }
      if (finishedEvents === null || fromScratch) {
        setFinishedEvents(response.data.data);
      } else {
        setFinishedEvents(prevObjects => [...prevObjects, ...response.data.data]);
      }
      setNextUrl(response.data.nextPageUrl);
    })
    .catch((error) => {
      if (latestRequestIdRef.current !== requestId) {
        return;
      }
      if (error.response) {
        // Server responded with a status other than 200 range
        if (error.response.status === 403 || error.response.status === 401) {
          // Handle 403 Forbidden
          setHasAccess(false);
          console.log("Setting has access to false");
        } else {
          console.error('Error: ', error.response.data);
        }
      } else {
        console.error(error);  
      }
    })
    .finally(() => {
      if (latestRequestIdRef.current === requestId) {
        setLoading(false);
      }
    });
  }, [finishedEvents, loading]);

  const handleFinishedInputChange = (event) => {
    setFinishedInput(event.target.value);
  };
  const handleFinished = () => {
    axiosInstance
    .post(`/artEvents`, { wikiArticleLink: finishedInput, type: eventType })
    .then((response) => {
      if (finishedEvents === null) {
        setFinishedEvents(response.data);
      } else {
        setFinishedEvents(prevObjects => [response.data, ...prevObjects]);  
      }
      setFinishedInput("");
    })
    .catch((error) => {
      console.error(error);
    });
  };

  const lastObjectRef = useCallback(node => {
    if (loading) return;

    if (observer.current) {
      observer.current.disconnect();
    }
    observer.current = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        fetchFinishedEvents(nextUrl);
      }
    });
    if (node) {
      observer.current.observe(node);
    }
  }, [loading, nextUrl, fetchFinishedEvents]);

  const curUserIsMe = () => {
    return (myUser && effectiveUserId() === myUser.myUserInfo.myUserId);
  }

  const isMobileDeviceExceptAndroid = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    return /iphone|ipad|ipod|windows phone|blackberry/i.test(userAgent);
  };

  const isFirefox = () => {
    return navigator.userAgent.toLowerCase().includes('firefox');
  };

  const isMobile = () => window.innerWidth <= 768;

  const handleItemClick = (item) => {
    if (isMobile()) {
      setSelectedItem(item); // Open modal on mobile
    } else {
      navigate(`/arts/${item.art.id}`); // Navigate on desktop
    }
  };

  const getGlobalManualTag = (eventTags) => {
    return eventTags?.find(tag => tag.type === 3)?.name || "like";
  };

  const handleGlobalManualTagSelect = (item, selectedTag) => {
    if (!item?.event?.id) {
      return;
    }
    const existingTags = item.event.eventTags?.map((tag) => tag.name) || [];
    const updatedTags = [
      selectedTag,
      ...existingTags.filter((tag) => !globalManualTags.includes(tag)),
    ];

    axiosInstance
      .post(`/artEvents/tag/${item.event.id}/tag`, { tags: updatedTags })
      .then((response) => {
        const updatedEvent = response.data.event;
        setFinishedEvents((prevEvents) => {
          if (!prevEvents) {
            return prevEvents;
          }
          return prevEvents.map((prevItem) =>
            prevItem.event.id === updatedEvent.id
              ? { ...prevItem, event: updatedEvent }
              : prevItem
          );
        });
        setOpenGlobalManualTagEventId(null);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const initialFetchDoneRef = useRef(false);
  useEffect(() => {
    if (!hasAccess || finishedEvents !== null || curUser !== null || fetching) {
      return;
    }
    if (initialFetchDoneRef.current) {
      return;
    }
    initialFetchDoneRef.current = true;
    setFetching(true);
    fetchFinishedEvents(nextUrl);
    fetchUnfinishedRecomsCount();
    fetchCurUser();
    fetchFollowCounts();
    fetchRelevantTags(alreadySelectedTagIds);
  }, [
    hasAccess,
    finishedEvents,
    curUser,
    fetching,
    fetchFinishedEvents,
    nextUrl,
    alreadySelectedTagIds,
  ]);

  if (hasAccess && (finishedEvents === null || curUser === null)) {
    return (
      <div></div>
    )
  }

  const language = myUser ? myUser.myUserSettings.lang : 'ru';
  const followersLabel = language === "ru" ? "Подписчики" : "Followers";
  const followeesLabel = language === "ru" ? "Подписки" : "Followings";
  const followersText = followersCount !== null ? `${followersLabel} (${followersCount})` : followersLabel;
  const followeesText = followeesCount !== null ? `${followeesLabel} (${followeesCount})` : followeesLabel;

  let buttonTextLocalizeKey = "addFinished";
  if (eventType === "like") {
    buttonTextLocalizeKey = "like";
  } else if (eventType === "todo") {
    buttonTextLocalizeKey = "addTodo";
  }

  // console.log("finishedEvents[0].event.chatId: " + finishedEvents[0].event.chatId);

  // Links to other types of events: start
  // TODO: move it to a separate user page component.
  const likesLink = `/users/${effectiveUserId()}/likes`;
  const classLikes = (eventType === "like" ? "underline" : "");

  const todosLink = `/users/${effectiveUserId()}/todos`;
  const classTodos = (eventType === "todo" ? "underline" : "");

  const finishedLink = `/users/${effectiveUserId()}/finished`;
  const classFinished = (eventType === "finished" ? "underline" : "");

  // Links to other types of events: end

  return (
    <div className="container mx-auto px-1 md:px-2 w-full lg:w-3/4">
      {/* <div className="container mx-auto">
        {
          myUser && effectiveUserId() !== myUser.myUserInfo.myUserId &&
            <TextUserPair user={curUser} userId={effectiveUserId()} hideRecomInput={true}/>
        }        
      </div> */}
      {
      (hasAccess === false) ?
        <div className="flex justify-center text-center">
          {language === "ru" ? "Приватный аккаунт, подпишитесь на пользователя и дождитесь подтверждения" : "Account is private, subscribe to user and wait for approval"}
        </div> 
        :
          <>
            {
            (eventType === 'like') &&
            <div>
              {/*<div className="flex justify-between items-center mt-2 mb-1 px-2">
                <div className="flex justify-center items-center space-x-2">
                  <Link to={"/logbookHistory?userId="+effectiveUserId()}>
                      <div className="container mx-auto flex justify-center items-center">
                      <div className="flex group-hover:hidden">
                        <img className="mt-0.5 max-w-9 max-h-9" src="/calendar_icon_2.png" alt="Calendar" style={{ filter: 'var(--icon-filter)' }} />
                      </div>
                    </div>
                  </Link>
                  {
                  (myUser && effectiveUserId() === myUser.myUserInfo.myUserId) &&
                    <Link to="/settings">
                      <img
                        src="/settings_icon.png"
                        alt={language === "ru" ? "Настройки" : "Settings"}
                        className="w-9 h-9 cursor-pointer"
                        style={{ filter: 'var(--icon-filter)' }}
                      />
                    </Link>
                  }
                </div>
              </div> */}
              <div>
                <Paper radius="md" p="sm" shadow="xs" style={{ backgroundColor: 'var(--app-surface-hover)' }}>
                  <Stack gap="sm">
                    <Group gap="sm" align="center" wrap="wrap">
                      <Group gap="sm" align="center" wrap="wrap">
                        <TextUserPair user={curUser} hideRecomInput={true} />
                        {(myUser && effectiveUserId() === myUser.myUserInfo.myUserId) && (
                          <ActionIcon
                            component={Link}
                            to="/settings"
                            variant="light"
                            size="lg"
                            radius="md"
                            aria-label={language === "ru" ? "Настройки" : "Settings"}
                          >
                            <Image src="/settings_icon.png" alt={language === "ru" ? "Настройки" : "Settings"} w={18} h={18} fit="contain" style={{ filter: 'var(--icon-filter)' }} />
                          </ActionIcon>
                        )}
                      </Group>
                    </Group>

                    <Group justify="space-between" align="center" wrap="wrap" w="100%">
                      <Group gap="sm" wrap="wrap">
                        <Button
                          component={Link}
                          to={`/users?onlyMyFollowers=true&forUserId=${effectiveUserId()}`}
                          variant="light"
                          size="sm"
                          radius="md"
                        >
                          {followersText}
                        </Button>
                        <Button
                          component={Link}
                          to={`/users?onlyMyFollowees=true&forUserId=${effectiveUserId()}`}
                          variant="light"
                          size="sm"
                          radius="md"
                        >
                          {followeesText}
                        </Button>
                        {curUserIsMe() && (
                          <Button
                            component={Link}
                            to={`/users/${effectiveUserId()}/recommendationsIncoming`}
                            variant="light"
                            size="sm"
                            radius="md"
                          >
                            {language === "ru" ? "Рекомендации друзей" : "Recommendations of friends"}
                          </Button>
                        )}
                      </Group>
                      <Button
                        component={Link}
                        to={`/logbookHistory?userId=${effectiveUserId()}`}
                        variant="light"
                        size="sm"
                        radius="md"
                        leftSection={<Image src="/calendar_icon_2.png" alt="Calendar" w={14} h={14} fit="contain" style={{ filter: 'var(--icon-filter)' }} />}
                      >
                        {language === "ru" ? "Журнал" : "Logbook"}
                      </Button>
                    </Group>

                    {(myUser && curUser.id !== myUser.myUserInfo.myUserId && curUser.matchScore) && (
                      <Text size="sm" c="dimmed" lh="sm">
                        {Math.floor(curUser.matchScore * 100) + "%" + " "}
                        {language === "ru" ? "совпадение вкусов" : "match of tastes"}
                        <br />
                        {language === "ru"
                          ? `(на основе ${curUser.matchArtsCount} произведений)`
                          : "(based on ${curUser.matchArtsCount} arts)"}
                      </Text>
                    )}
                  </Stack>
                </Paper>
              </div>
            </div>
            }

            {
            (finishedEvents && finishedEvents.length == 0) && artNameTerm === '' && !loading &&
              <div className="mt-5 justify-center text-center">
                {
                language === "ru"
                ?                  
                  (myUser && effectiveUserId() === myUser.myUserInfo.myUserId)
                  ?
                    eventType.includes('recommendation')
                    ?
                      <>
                        
                      </>
                    :
                      <>
                        Вы пока не добавили ни одного произведения в свою библиотеку.
                        Перейдите в поиск <img className="inline max-w-6 max-h-6" src="/add_icon.png" style={{ filter: 'var(--icon-filter)' }} /> и добавьте произведения.
                      </>
                  :
                    <>
                      Пользователь пока не добавил ни одного произведения в свою библиотеку.
                    </>
                :
                  (myUser && effectiveUserId() === myUser.myUserInfo.myUserId)
                  ?                    
                    eventType.includes('recommendation')
                    ?
                      <>
                        No personal recommendations yet.
                      </>
                    :
                      <>
                        You have not added any arts yet to your library.
                        Go to search <img className="inline max-w-6 max-h-6" src="/add_icon.png" style={{ filter: 'var(--icon-filter)' }} /> and add arts.
                      </>                    
                  :
                    <>
                      The user has not added any arts yet to their library.
                    </>
                }
              </div>
            }

            {
            (finishedEvents && finishedEvents.length > 0 || artNameTerm.length > 0 || eventType.includes('recommendation')) &&
            <div className={"rounded-md border-dotted left-0 w-full z-50 justify-center" + (myUser ? " bottom-20" : " bottom-0")} style={{ borderColor: "var(--mantine-color-default-border)" }}>

              <div className="flex justify-center items-center space-x-4">
                {
                myUser && effectiveUserId() === myUser.myUserInfo.myUserId &&
                  (
                    eventType.includes('recommendation')
                    &&
                      <div>
                        <div className="flex justify-center items-center text-center space-x-4">
                          <Link to={`/users/${effectiveUserId()}/recommendationsIncoming`}>
                            <Button
                              variant="light"
                              size="sm"
                              radius="md"
                              className={eventType === "recommendationIncoming" ? "underline" : ""}
                            >
                              {language === "ru" ? "Мне" : "To me"} 
                            </Button>
                          </Link>
                          <Link to={`/users/${effectiveUserId()}/recommendationsOutgoing`}> 
                            <Button
                              variant="light"
                              size="sm"
                              radius="md"
                              className={eventType === "recommendationOutgoing" ? "underline" : ""}
                            >
                              {language === "ru" ? "От меня" : "From me"} 
                            </Button>
                          </Link>  
                        </div>
                      </div>
                  )                
                }
              </div>

              <div className="flex justify-center items-center mt-6 mb-2">
                <div className="flex font-[sans-serif]">
                  <TextInput
                    ref={searchInputRef}
                    type="search"
                    className="w-64"
                    value={artNameTerm}
                    onChange={(event) => {
                      const nextTerm = event.currentTarget.value;
                      const eventsFetchUrl = `/artEvents/${effectiveUserId()}/${eventType}?${window.location.search}&artNameTerm=${nextTerm}`;
                      fetchFinishedEvents(eventsFetchUrl, true);

                      setArtNameTerm(nextTerm); // to intercept in tags selection
                      setShouldFocus(true);
                    }}
                    placeholder={language === "ru" ? ( (!myUser || effectiveUserId() !== myUser.myUserInfo.myUserId) ? "Поиск в библиотеке пользователя" : "Поиск в моей библиотеке") : ( (!myUser || effectiveUserId() !== myUser.myUserInfo.myUserId) ? "Search in user's library" : "Search in my library")}
                    leftSection={
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192.904 192.904" width="16px"
                        className="rotate-120" style={{ fill: "var(--mantine-color-dimmed)" }}>
                        <path
                          d="m190.707 180.101-47.078-47.077c11.702-14.072 18.752-32.142 18.752-51.831C162.381 36.423 125.959 0 81.191 0 36.422 0 0 36.423 0 81.193c0 44.767 36.422 81.187 81.191 81.187 19.688 0 37.759-7.049 51.831-18.751l47.079 47.078a7.474 7.474 0 0 0 5.303 2.197 7.498 7.498 0 0 0 5.303-12.803zM15 81.193C15 44.694 44.693 15 81.191 15c36.497 0 66.189 29.694 66.189 66.193 0 36.496-29.692 66.187-66.189 66.187C44.693 147.38 15 117.689 15 81.193z">
                        </path>
                      </svg>
                    }
                    rightSection={
                      (isMobileDeviceExceptAndroid() || isFirefox()) && artNameTerm ? (
                        <ActionIcon
                          variant="subtle"
                          color="gray"
                          size="sm"
                          onClick={() => {
                            const eventsFetchUrl = `/artEvents/${effectiveUserId()}/${eventType}?${window.location.search}&artNameTerm=`;
                            fetchFinishedEvents(eventsFetchUrl, true);

                            setArtNameTerm('');
                            setShouldFocus(true);
                            if (searchInputRef.current) {
                              searchInputRef.current.focus();
                            }
                          }}
                          aria-label={language === "ru" ? "Очистить поиск" : "Clear search"}
                        >
                          &times;
                        </ActionIcon>
                      ) : null
                    }
                    styles={{
                      input: {
                        backgroundColor: "var(--mantine-color-default)",
                        color: "var(--mantine-color-text)",
                      },
                      section: { color: "var(--mantine-color-dimmed)" }
                    }}
                    radius="xl"
                  />
                </div>
                {/* {
                (finishedEvents && finishedEvents.length > 5) &&
                  <div className="ml-2 text-4xl leading-none transform translate-y-[-2px] hover:cursor-pointer hover:text-gray-400" onClick={toggleGridCols}>
                    ⊞
                  </div>
                } */}
                {/*
                <div className="text-3xl">
                  {
                    eventType === "like" &&
                    <ShareButton
                      url={
                        window.location.href
                      }
                      text={
                        ""
                      }
                      overrideButtonText="🔗"
                    />
                  }
                </div>
                */}
              </div>
              {
              // showTags &&
              <div className="mb-2">
                <SelectableTags language={language} relevantTags={relevantTags !== null ? relevantTags : []} alreadySelectedTags={ relevantTags ? relevantTags.filter((t) => alreadySelectedTagIds.includes(t.tag.id)) : []} onSelectionChange={(tags) => {
                  const tagParams = tags.map((t) => { return "tags="+t.tag.id; }).join("&");

                  const url = 'https://wowcontent.lol';
                  // const url = 'http://localhost:8080'
                  let urlEventType = "likes";
                  if (eventType === "recommendationIncoming") {
                    urlEventType = "recommendationsIncoming";
                  } else if (eventType === "recommendationOutgoing") {
                    urlEventType = "recommendationsOutgoing";
                  }
                  window.history.pushState({}, '', `${url}/users/${curUser.id}/${urlEventType}${ tagParams ? "?"+tagParams : "" }`);

                  const eventsFetchUrl = `/artEvents/${effectiveUserId()}/${eventType}?${tagParams}&artNameTerm=${artNameTerm}`;
                  fetchFinishedEvents(eventsFetchUrl, true);

                  const tagIds = tags.map((t) => { return t.tag.id; });
                  fetchRelevantTags(tagIds);
                }} />
              </div>
              }
            </div>
            }
            {/* Grid */}
            {(() => {
              const cols = window.innerWidth >= 768 ? 6 : 4;
              const elements = [];
              for (let i = 0; i < finishedEvents.length; i += cols) {
                const rowItems = finishedEvents.slice(i, i + cols);
                const selectedInRow = selectedGridItemIdx !== null && selectedGridItemIdx >= i && selectedGridItemIdx < i + cols;
                const selectedItem = selectedInRow ? finishedEvents[selectedGridItemIdx] : null;
                const detail = selectedItem ? gridArtDetails[selectedItem.art.id] : null;

                elements.push(
                  <div key={`row-${i}`} className="grid grid-cols-4 md:grid-cols-6 gap-1.5 mb-1.5">
                    {rowItems.map((item, j) => {
                      const idx = i + j;
                      return (
                        <div
                          key={idx}
                          ref={idx === finishedEvents.length - 1 ? lastObjectRef : null}
                          className="cursor-pointer"
                          onClick={() => handleSelectGridItem(idx)}
                        >
                          <div className="relative">
                            <ArtThumbnail art={item.art} displayCheckmark={eventType !== "like"} displayTag={false} />
                            {eventType.includes('like') && getGlobalManualTag(item.event.eventTags) && (
                              <div
                                className="absolute top-1 right-1 rounded-full flex items-center justify-center text-sm leading-none"
                                style={{
                                  width: 31,
                                  height: 31,
                                  backgroundColor: `var(--mantine-color-${tagBadgeColor(getGlobalManualTag(item.event.eventTags), 3)}-filled)`,
                                  border: `2px solid white`,
                                  boxShadow: '0 1px 4px rgba(0,0,0,0.4)'
                                }}
                              >
                                {tagName(getGlobalManualTag(item.event.eventTags), language).split(' ')[0]}
                              </div>
                            )}
                          </div>
                          {eventType.includes('recommendation') && (
                            <div className="flex items-center justify-center -space-x-2 mt-1">
                              {(item.event.eventTags || [])
                                .filter((tag) => tag.imgUrl)
                                .slice(0, 5)
                                .map((tag, avatarIndex) => (
                                  <img
                                    key={`${tag.imgUrl}-${avatarIndex}`}
                                    src={tag.imgUrl}
                                    alt={tag.name || "avatar"}
                                    className="w-6 h-6 rounded-full"
                                    style={{ border: "1px solid var(--mantine-color-default-border)", backgroundColor: "var(--mantine-color-default)" }}
                                  />
                                ))}
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                );

                if (selectedInRow && selectedItem) {
                  const artData = detail || selectedItem.art;
                  const localized = localizeArt(selectedItem.art, language);
                  const description = language === 'ru'
                    ? (artData.ruDescription || artData.description)
                    : (artData.description || artData.ruDescription);
                  const genres = selectedItem.art.genres || detail?.genres || [];
                  const author = selectedItem.art.author || detail?.author || artData?.videoGameDeveloper || '';
                  elements.push(
                    <Paper key={`detail-${i}`} ref={scrollDetailIntoView} shadow="xs" radius="md" className="mb-2 p-3" style={{ backgroundColor: 'var(--app-surface-hover)' }}>
                      <div className="flex gap-3">
                        <Link to={`/arts/${selectedItem.art.id}`}>
                          <img src={selectedItem.art.thumbnailUrl} alt="" className="w-16 h-auto object-cover rounded-md" />
                        </Link>
                        <div className="flex-1 min-w-0">
                          <div className="flex items-start justify-between gap-2">
                            <Link to={`/arts/${selectedItem.art.id}`}>
                              <Text size="sm" fw={600}>{localized.name + formatYear(selectedItem.art.year, language)}</Text>
                            </Link>
                            <Link to={`/artEvents/${selectedItem.event.id}`} className="flex items-center flex-shrink-0">
                              <img
                                src="/chat_icon.png"
                                alt=""
                                className="w-5 h-5 opacity-80"
                                style={{ filter: 'var(--icon-filter)' }}
                              />
                              {selectedItem.chat?.messageCount > 0 && (
                                <Text component="span" className="ml-1" size="xs" c="dimmed">
                                  {selectedItem.chat.messageCount}
                                </Text>
                              )}
                            </Link>
                          </div>
                          {author && (
                            <Text size="xs" c="dimmed" className="mt-0.5">
                              {selectedItem.art.category === 1
                                ? (language === 'ru' ? 'Режиссёр' : 'Director')
                                : selectedItem.art.category === 2
                                  ? (language === 'ru' ? 'Разработчик' : 'Developer')
                                  : (language === 'ru' ? 'Автор' : 'Author')
                              }: {author}
                            </Text>
                          )}
                          {genres.length > 0 && (
                            <Text size="xs" c="dimmed" className="mt-0.5">
                              {genres.join(', ')}
                            </Text>
                          )}
                          <div className="mt-1">
                            <PlatformRatings art={selectedItem.art} center={false} />
                          </div>
                          {eventType.includes('like') && (
                            <div className="flex items-center gap-1 mt-1 flex-wrap" data-global-tag-menu-id={selectedItem.event.id}>
                              <TagBadge
                                component="button"
                                type="button"
                                className="cursor-pointer"
                                radius="md"
                                size="xs"
                                color={tagBadgeColor(getGlobalManualTag(selectedItem.event.eventTags), 3)}
                                variant="filled"
                                rightSection={curUserIsMe() ? <span className="text-[10px] opacity-70">▼</span> : undefined}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  if (curUserIsMe()) {
                                    setOpenGlobalManualTagEventId(
                                      openGlobalManualTagEventId === selectedItem.event.id ? null : selectedItem.event.id
                                    );
                                  }
                                }}
                              >
                                {tagName(getGlobalManualTag(selectedItem.event.eventTags), language)}
                              </TagBadge>
                              {curUserIsMe() && openGlobalManualTagEventId === selectedItem.event.id && (
                                <div className="flex flex-wrap gap-1">
                                  {globalManualTags.filter(tag => tag !== getGlobalManualTag(selectedItem.event.eventTags)).map((tag) => (
                                    <TagBadge
                                      key={tag}
                                      component="button"
                                      type="button"
                                      radius="md"
                                      size="xs"
                                      className="cursor-pointer"
                                      color={tagBadgeColor(tag, 3)}
                                      variant="filled"
                                      onClick={(e) => { e.stopPropagation(); handleGlobalManualTagSelect(selectedItem, tag); }}
                                    >
                                      {tagName(tag, language)}
                                    </TagBadge>
                                  ))}
                                </div>
                              )}
                            </div>
                          )}
                          {description && (
                            <Text size="xs" className="mt-1" style={{ lineHeight: 1.4 }}>
                              {description}
                            </Text>
                          )}
                        </div>
                      </div>
                    </Paper>
                  );
                }
              }
              return elements;
            })()}
            {/* <button onClick={handleNavigation}>Navigate</button> */}
            
          </>
      }
      
    </div>
  );
}

export default PersonalArtEvents;
